import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './finance-calculators.component.scss';
var FinanceCalculators = /** @class */ (function (_super) {
    tslib_1.__extends(FinanceCalculators, _super);
    function FinanceCalculators(element) {
        return _super.call(this, element) || this;
    }
    FinanceCalculators.prototype.init = function () { };
    FinanceCalculators.prototype.bindEvents = function () { };
    return FinanceCalculators;
}(Base));
export { FinanceCalculators };



//////////////////
// WEBPACK FOOTER
// ./components/finance-calculators/finance-calculators.component.ts
// module id = 1075
// module chunks = 0